var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C4 0.89375 3.10625 0 2 0C0.89375 0 0 0.89375 0 2L0 23C0 25.7625 2.2375 28 5 28L30 28C31.1063 28 32 27.1063 32 26C32 24.8937 31.1063 24 30 24L5 24C4.45 24 4 23.55 4 23L4 2ZM29.4125 7.4125C30.1938 6.63125 30.1938 5.3625 29.4125 4.58125C28.6313 3.8 27.3625 3.8 26.5812 4.58125L20 11.1687L16.4125 7.58125C15.6313 6.8 14.3625 6.8 13.5813 7.58125L6.58125 14.5813C5.8 15.3625 5.8 16.6313 6.58125 17.4125C7.3625 18.1938 8.63125 18.1938 9.4125 17.4125L15 11.8313L18.5875 15.4187C19.3687 16.2 20.6375 16.2 21.4188 15.4187L29.4188 7.41875L29.4125 7.4125Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002);
export default __webpack_public_path__ + "static/media/002.5a915f04a012c4f7ecee172a456cad49.svg";
export { ForwardRef as ReactComponent };